import { useCallback, useState } from 'react';
import { BlockStack, Button, Checkbox, OptionList, Popover, Text, TextField } from '@shopify/polaris';

function ShopifyOnboardStep1({
  selectedLanguage, setSelectedLanguage,
  // installLocation, setInstallLocation,
  // themeOptions,
  newsletterOptIn, setNewsletterOptIn,
  contactEmail, setContactEmail,
  translate: lng
}) {

  const [langPopoverActive, setLangPopoverActive] = useState(false);
  const toggleLangPopover = useCallback(() => setLangPopoverActive((v) => !v), []);

  const languageOptions = [
    { label: lng.English || 'English', value: 'en' },
    { label: lng.Spanish || 'Spanish', value: 'es' },
    { label: lng.German || 'German', value: 'de' },
    { label: lng.French || 'French', value: 'fr' },
  ];

  const selectedLabel = languageOptions.find((o) => o.value === selectedLanguage)?.label || 'English';

  // //use dynamic themes from API, fallback to static option
  // const installOptions = themeOptions && themeOptions.length > 0
  //   ? themeOptions
  //   : [{ label: lng.CurrentTheme || 'My current theme (Default)', value: '0' }];

  return (
    <>
      <div className="shopify-onboard-step1-card">
        {/* Left - Welcome image */}
        <div className="shopify-onboard-step1-image">
          <img
            src="/images/onboard-welcome.svg"
            alt="Welcome to WiserNotify"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>

        {/* Right - Form content */}
        <div className="shopify-onboard-step1-form">
          <BlockStack gap={400}>

            {/* Welcome heading */}
            <BlockStack gap={200}>
              <Text as="h2" variant="headingLg" fontWeight="bold">
                {lng.WelcomeTitle || 'Welcome to WiserNotify!'} 👋
              </Text>
              <Text as="p" variant="bodyMd" tone="subdued">
                {lng.WelcomeDesc || "Let's set up your store to collect and display unlimited social proof notifications. It's simple and takes just 2 minutes."}
              </Text>
            </BlockStack>

            {/* Settings language */}
            <BlockStack gap={100}>
              <Text variant="bodyMd" fontWeight="medium">{lng.SettingsLanguage || 'Settings language'}</Text>
              <Popover
                active={langPopoverActive}
                activator={
                  <Button
                    onClick={toggleLangPopover}
                    disclosure
                    fullWidth
                    textAlign="left"
                  >
                    {selectedLabel}
                  </Button>
                }
                onClose={toggleLangPopover}
                fullWidth
              >
                <OptionList
                  options={languageOptions}
                  selected={[selectedLanguage]}
                  onChange={(val) => { setSelectedLanguage(val[0]); setLangPopoverActive(false); }}
                />
              </Popover>
            </BlockStack>

            {/* Install location - commented out */}
            {/* <Select
              label={lng.InstallTitle || 'Where would you like to install it?'}
              options={installOptions}
              value={installLocation}
              onChange={(val) => setInstallLocation(val)}
            /> */}

            {/* Newsletter opt-in - commented out for now */}
            {/* <Checkbox
              label={lng.NewsletterLabel || 'Get product updates and newsletters from WiserNotify. Unsubscribe at any time.'}
              checked={newsletterOptIn}
              onChange={(val) => setNewsletterOptIn(val)}
            />

            <TextField
              label=""
              labelHidden
              type="email"
              autoComplete="email"
              value={contactEmail}
              onChange={(val) => setContactEmail(val)}
              readOnly
            />

            <Text variant="bodySm" tone="subdued">
              {lng.AdminEmailNote || 'Setup guidance emails will be sent to your admin email. You can update it later in Settings.'}
            </Text> */}

          </BlockStack>
        </div>
      </div>

      {/* Terms footer */}
      <div className="shopify-onboard-step1-footer">
        <Text variant="bodySm" tone="subdued" alignment="center">
          {lng.TOSPrefix || 'By using this service, I confirm that I have read and agree to the'}{' '}
          <a href="https://wisernotify.com/termsconditions/" target="_blank" rel="noopener noreferrer">
            {lng.TermsOfService || 'Terms of Service'}
          </a>{' '}
          {lng.And || 'and'}{' '}
          <a href="https://wisernotify.com/privacypolicy/" target="_blank" rel="noopener noreferrer">
            {lng.PrivacyPolicy || 'Privacy Policy'}
          </a>.
        </Text>
      </div>
    </>
  );
}

export default ShopifyOnboardStep1;
